import { render, staticRenderFns } from "./carrier_form.vue?vue&type=template&id=9798c992&"
import script from "./carrier_form.vue?vue&type=script&lang=js&"
export * from "./carrier_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports